import { render } from "./LanguageSwitcher.vue?vue&type=template&id=65486f20&scoped=true"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=65486f20&scoped=true&lang=css"
import "./LanguageSwitcher.vue?vue&type=style&index=1&id=65486f20&lang=css"

import exportComponent from "E:\\laragon\\www\\RDRS_Union_Federation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65486f20"]])

export default __exports__